<template>
  <div class="game_detail_area">
    <div class="swiper">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="red" v-if="banner.length > 0">
        <van-swipe-item v-for="(item,i) in banner" :key="i">
          <img :src="item" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="hotOne">
      <img :src="icon" alt="" />
      <div class="hotText">
        <h3>{{ app_name }}</h3>
      </div>
    </div>
    <div class="gameMessage" v-if="intro != ''">
      <p class="titleBox">
        <span class="line">|</span>
        <span class="gameTitle">游戏信息</span>
      </p>
      <div class="message" v-html="intro">
      </div>
    </div>
    <div class="gameFooter">
      <div class="footer-left">
        <van-icon name="star" class="star" :class="{'collect': isCollect}" @click="collect"/>
      </div>
      <div class="footer-right">
        <van-button class="start" :loading="startLoading"  @click="start" v-if="isApp&&(conf&&conf.start_btn == 1)">启动</van-button>
        <van-button class="start" :loading="startLoading"  @click="start2" v-if="!isApp&&(conf&&conf.start_btn == 1&&conf.ios_game_url != '')&&isiOS">启动</van-button>
        <van-button class="start" :loading="startLoading"  @click="start2" v-if="!isApp&&(conf&&conf.start_btn == 1&&conf.android_game_url != '')&&!isiOS">启动</van-button>
        <div class="jy-Icon" @click="chooseGame">
        <van-icon name="shop-collect-o" />
          <p>交易行</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      app_name: "",
      intro: "",
      icon: "",
      banner: [],
      isCollect: false,
      conf: null,
      startLoading: false,
      prop_trade: 0,
      role_trade: 0
    };
  },
  created() {
  },
  mounted() {
    this.getGameDetail();
    if(this.$route.query.from) {
      window.localStorage.setItem('indexfrom',this.$route.query.from)
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    isApp() {
      return this.$store.state.isApp
    },
    isiOS() {
      var u = navigator.userAgent;
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    //启动
    start() {
      var that = this
      this.startLoading = true
      setTimeout(() => {
        that.startLoading = false
      },2000)
      if(this.isiOS) {
        // if(this.conf.ios_game_url != '') {
        //   window.location.href = this.conf.ios_game_url
        // }
        var e = {
          game_url: this.conf.ios_game_url,
          bundle_id: this.conf.ios_package,
          store_id: this.conf.ios_appid,
          game_page: this.conf.page,
          open_type: this.conf.otype
        }
        window.webkit.messageHandlers.startGameWebToNative.postMessage(JSON.stringify(e));
      }else {
        // if(this.conf.android_game_url != '') {
        //   window.open(this.conf.android_game_url)
        // }
        var e = {
          game_url: this.conf.android_game_url,
          bundle_id: this.conf.android_package,
          game_page: this.conf.page,
          open_type: this.conf.otype
        }
        window.android.startGameWebToNative(JSON.stringify(e));
      }
    },
    start2() {
      var that = this
      this.startLoading = true
      setTimeout(() => {
        that.startLoading = false
      },2000)
      if(this.isiOS) {
        if(this.conf.ios_game_url != '') {
          window.location.href = this.conf.ios_game_url
        }
      }else {
        if(this.conf.android_game_url != '') {
          window.open(this.conf.android_game_url)
        }
      }
    },
    getGameDetail() {
      this.$Ajax("game/app-info", { app_id: this.$route.query.app_id },'get').then((rs) => {
        if (rs.code == 200) {
          this.app_name = rs.data.app_name;
          this.intro = rs.data.intro;
          this.icon = rs.data.icon;
          this.banner = rs.data.game_paths;
          this.prop_trade = rs.data.prop_trade
          this.role_trade = rs.data.role_trade
          if(rs.data.is_collect) {
            this.isCollect = rs.data.is_collect == 0 ? false : true
          }else {
            this.isCollect = false
          }
          if(rs.data.conf) {
            this.conf = rs.data.conf
          }
        }
      });
    },
    chooseGame() {
      this.$store.commit('resetServer')
      this.$store.commit('resetHomeServer')
      this.$store.commit('setCt','')
      this.$store.commit('setCi','')
      this.$store.commit('setCt2','')
      this.$store.commit('setCi2','')
      this.$store.commit('setGameInfo', {
        name: this.app_name,
        icon: this.icon,
        id: this.$route.query.app_id
      })

      //道具市场 角色市场判断
      this.$store.commit('setHome',{prop_trade:this.prop_trade,role_trade:this.role_trade})
      if(this.prop_trade == 0) {
        this.$store.commit('changeHome',2)
      }else {
        this.$store.commit('changeHome',1)
      }

      //角色市场 筛选全部重置
      this.$store.commit('resetAccPx')
      this.$toast({
        message: '正在前往交易行',
        duration: '2000',
        onClose: () => {
          if(this.isiOS) {
            window.location.href = window.location.origin + '/home?id=' + this.$route.query.app_id
          }else {
            this.$router.push({name: 'home',
              query: {
                id: this.$route.query.app_id
              }
            })
          }

          // this.$filterPop({
          //   type: 'server',
          //   direction: 'up'
          // })
        }
      })
    },
    //收藏
    collect() {
      if(this.isLogin) {
        var api = this.isCollect ? 'collect/remove' : 'collect/add'
        this.$Ajax(api,{
          app_id: this.$route.query.app_id
        },'post').then(rs => {
          if(rs.code == 200) {
            this.isCollect = !this.isCollect
            this.$toast({
              message: this.isCollect ? '收藏成功' : '取消收藏成功'
            })
          }
        })
      }else {
        this.$filterPop({
          type: "login",
          direction: "up",
          onSuccess: () => {
            this.getGameDetail()
            setTimeout(() => {
              var api = this.isCollect ? 'collect/remove' : 'collect/add'
              this.$Ajax(api, {
                app_id: this.$route.query.app_id
              }, 'post').then(rs => {
                if (rs.code == 200) {
                  this.isCollect = !this.isCollect
                  this.$toast({
                    message: this.isCollect ? '收藏成功' : '取消收藏成功'
                  })
                }
              })
            },500)
          },
        });
      }
      // this.isCollect = !this.isCollect
    }
  },
};
</script>

<style scoped lang="less">
.game_detail_area {
  padding-top: 1rem;
}
.swiper {
  border-radius: 1rem;
  overflow: hidden;
  margin: 0 1rem 1rem;
  .van-swipe__indicators {
    bottom: 0px !important;
    left: 50%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  .van-swipe-item {
    color: #fff;
    text-align: center;
    // background-color: #39a9ed;
    border-radius: 1rem;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.hotOne {
  display: flex;
  align-items: flex-start;

  border-radius: 1rem;
  margin: 1rem;
  padding: 1rem;

  img {
    width: 5rem;
    height: 5rem;
    margin-right: 1rem;
    border-radius: .8rem;
  }

  .hotText {
    margin-top: 0.25rem;
    margin-left: 0.2rem;

    .oneSpecial {
      padding: 0.5rem 0;

      span {
        color: white;
        background-color: #ffca34;
        border-radius: 1rem;
        padding: 0.2rem 0.8rem;
        margin-right: 0.5rem;
        font-size: 0.8rem;
      }
    }

    .oneSize {
      font-size: 0.8rem;
    }
  }
}

.gameMessage {
  width: 35.8rem;
  margin: 0.8rem 0.8rem 8rem;
  background: #fff;
  padding: 0.8rem;
  border-radius: 0.75rem;
  .titleBox {
    font-size: 1.6rem;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;

    .line {
      color: red;
      font-weight: 800;
      padding-right: 0.5rem;
      margin-bottom: 0.2rem;
    }
  }

  .message {
    line-height: 1.8;
    font-size: 1.3rem;
    word-break: break-all;
    color: #555;
    /deep/img,
    /deep/.img,
    /deep/.image {
      max-width: 100%;
      margin: 0 auto;
      display: block;
    }
  }
}

.gameFooter {
  position: fixed;
  bottom: calc(5.3rem + constant(safe-area-inset-bottom));
  bottom: calc(5.3rem + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  width: 100%;
  max-width: 525px;
  height: 7rem;
  padding: 0 2rem 1rem;
  .footer-left {
    .star {
      font-size: 3.6rem;
      color: #e3e3e3;
      &.collect {
        color: var(--theme);
      }
    }
  }
  .footer-right {
    display: flex;
    align-items: center;
  }
  .jy-Icon {
    margin-left: 2rem;
    text-align: center;
    font-size: 1.5rem;
    cursor: pointer;
    .van-icon {
      font-size: 2.2rem;
    }
  }

  .start {
    background: var(--theme);
    width: 12rem;
    height: 3.6rem;
    line-height: 3.6rem;
    border-radius: 1.75rem;
    text-align: center;
    color: #fff;
    margin-left: 5rem;
    font-size: 1.6rem;
  }
}
</style>
